const PROD_URL = 'https://disneycruise.disney.go.com';
const REGEX_ABSOLUTE_PATH = /https?:\/\/[\w\-\._<>]+\.[a-zA-Z]{2,6}[\w\-\._?=%<>\-&\/]*/g;

export { PROD_URL, REGEX_ABSOLUTE_PATH };
